




























import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { Record } from "@/types";

axios.defaults.baseURL = process.env.BASE_URL;

@Component
export default class QuestionnaireDownloader extends Vue {
  questionnaires: Array<Record> | null = null;

  @Prop()
  a: Record | undefined;
  private download(e) {
    window.open(process.env.BASE_URL + "download/?id=" + e.id, "_blank");
  }

  private reload(e) {
    e.meta.reloadingTxt = 3;
e.fileReady = false;

const MAX_RETRIES = 10; // Nombre max de tentatives
let retryCount = 0;

axios
  .get("/api/questionnaire-generate-file", { params: { id: e.id } })
  .then(ans => {
    console.log(ans);
    
    const checkFileReady = () => {
      if (retryCount >= MAX_RETRIES) {
        console.log("Arrêt des tentatives après", MAX_RETRIES, "essais.");
        e.meta.reloadingTxt = "Erreur";
        return;
      }

      setTimeout(() => {
        console.log("Vérification de la disponibilité du fichier " + e.id + "...");
        axios
          .get("/api/questionnaire-file-is-ready", { params: { id: e.id } })
          .then(ans => {
            console.log(ans);
            if (ans.data === true) {
              console.log("Fichier prêt !");
              e.fileReady = true;
              e.meta.reloadingTxt = 0;
            } else {
              retryCount++;
              e.meta.reloadingTxt = (e.meta.reloadingTxt + 1) % 4;
              checkFileReady();
            }
          })
          .catch(error => {
            console.error("Erreur lors de la vérification du fichier :", error);
            e.meta.reloadingTxt = "Erreur";
          });
      }, 30000);
    };

    checkFileReady();
  })
  .catch(error => {
    console.error("Erreur lors de la génération du fichier :", error);
    e.meta.reloadingTxt = "Erreur";
  });

  }
}
